import React, { Component } from 'react'
import { Container, Navbar } from 'react-bootstrap'
import { Link } from 'react-scroll';

class NavBarDrone extends Component {
    setNavExpanded = (expanded) => {
        this.setState({ navExpanded: expanded });
    }

    closeNav = () => {
        this.setState({ navExpanded: false });
    }

    state = {
        expanded: {}
    }

    render() {
      let navBarClass = 'navbar-default';
      if (this.props.scrolled) {
          navBarClass += ' scrolled';
      }
        return (
            <Navbar onToggle={this.setNavExpanded} expanded={this.state.navExpanded} className={navBarClass} variant="dark" id="mainNav" expand="lg" fixed="top">
                <Container>
                    <Navbar.Brand as={Link} to="/">ERC Drone Productions</Navbar.Brand>
                    <Navbar.Toggle aria-controls="basic-navbar-nav" />
                    <Navbar.Collapse id="basic-navbar-nav">
                        <ul className="navbar-nav ml-auto">
                            <li className="nav-item mr-0 mr-lg-5">
                                <Link
                                    activeClass="active"
                                    className="nav-link"
                                    to="drone"
                                    spy={true}
                                    smooth={true}
                                    offset={-56}
                                    duration={800}
                                    onClick={this.closeNav}>
                                    Home
                                </Link>
                            </li>
                            <li className="nav-item mr-0 mr-lg-5">
                                <Link
                                    activeClass="active"
                                    className="nav-link"
                                    to="services"
                                    spy={true}
                                    smooth={true}
                                    offset={-56}
                                    duration={800}
                                    onClick={this.closeNav}>
                                    Services
                                </Link>
                            </li>
                            <li className="nav-item mr-0 mr-lg-5">
                                <Link
                                    activeClass="active"
                                    className="nav-link"
                                    to="team"
                                    spy={true}
                                    smooth={true}
                                    offset={-56}
                                    duration={800}
                                    onClick={this.closeNav}>
                                    Team
                                </Link>
                            </li>
                            <li className="nav-item mr-0 mr-lg-5">
                                <Link
                                    activeClass="active"
                                    className="nav-link"
                                    to="equipment"
                                    spy={true}
                                    smooth={true}
                                    offset={-56}
                                    duration={800}
                                    onClick={this.closeNav}>
                                    Equipment
                                </Link>
                            </li>
                            <li className="nav-item mr-0 mr-lg-5">
                                <Link
                                    activeClass="active"
                                    className="nav-link"
                                    to="gallery"
                                    spy={true}
                                    smooth={true}
                                    offset={-56}
                                    duration={800}
                                    onClick={this.closeNav}>
                                    Gallery
                                </Link>
                            </li>
                            <li className="nav-item mr-0 mr-lg-5">
                                <Link
                                    activeClass="active"
                                    className="nav-link"
                                    to="faq"
                                    spy={true}
                                    smooth={true}
                                    offset={-56}
                                    duration={800}
                                    onClick={this.closeNav}>
                                    FAQ
                                </Link>
                            </li>
                            <li className="nav-item">
                                <Link
                                    activeClass="active"
                                    className="nav-link"
                                    to="contact"
                                    spy={true}
                                    smooth={true}
                                    offset={-56}
                                    duration={800}
                                    onClick={this.closeNav}>
                                    Contact
                                  </Link>
                            </li>
                        </ul>
                    </Navbar.Collapse>
                </Container>
            </Navbar>
        );
    }
}

export default NavBarDrone;



// WEBPACK FOOTER //
// ./src/components/Navbar/NavbarDrone.js